import dayjs from "dayjs";

import { Card } from "@design-system/Card/Card";
import { Modal } from "@design-system/Modal/Modal";
import { Text } from "@design-system/Text/Text";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  date?: string;
};

export const ClientApplicationUsageByUsersModal = ({
  isOpen,
  onClose,
  date,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      placeItems="center"
      transitionDirection="bottom"
    >
      <Card.Header>
        <Card.Header.Title>
          Application usage by users - {dayjs(date).format("DD/MM/YYYY")}
        </Card.Header.Title>
      </Card.Header>
      <Card.Body>
        <Text>Application usage by users table placeholder...</Text>
      </Card.Body>
    </Modal>
  );
};
